module.exports = __webpack_public_path__ + "img/mastercard-securecode.dece32f1.png";